import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/registration.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-xl mb-20" }, "Register for an Account ", -1)
const _hoisted_4 = { class: "container mt-35 sm-mt-0 sm-p-0 logo-header" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-8 sm-pdl-0 sm-pdr-0 order-2 order-md-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Choose an entity from below to create an account.", -1)
const _hoisted_8 = { class: "d-flex gap-20 mt-30" }
const _hoisted_9 = { class: "role-selection mt-10 mb-20" }
const _hoisted_10 = {
  class: "pdr-15",
  for: "participant"
}
const _hoisted_11 = {
  class: "pdr-15",
  for: "local"
}
const _hoisted_12 = {
  class: "pdr-15",
  for: "employer"
}
const _hoisted_13 = {
  class: "pdr-15",
  for: "payroll_company"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", { class: "sm-fs-xxs" }, "(Paying Agent)", -1)
const _hoisted_16 = { class: "mb-50" }
const _hoisted_17 = { class: "container flex-md-row sm-pdl-0 sm-pdr-0" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-12 mb-20" }
const _hoisted_20 = { class: "sm-mt-0 d-flex flex-row gap-30" }
const _hoisted_21 = { class: "w-100" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 hide-mobile" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"max-width":"100%","max-height":"90vh"},
    class: "rounded img-fluid",
    src: _imports_0,
    alt: "2FA Image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LocalOptions = _resolveComponent("LocalOptions")!
  const _component_ParticipantFields = _resolveComponent("ParticipantFields")!
  const _component_LocalFields = _resolveComponent("LocalFields")!
  const _component_EmployerFields = _resolveComponent("EmployerFields")!
  const _component_PublicFooter = _resolveComponent("PublicFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader),
    _createVNode(_component_AlertsComponent, { errors: $setup.generalErrors }, null, 8, ["errors"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "participant",
                      name: "UserType",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedUserType) = $event)),
                      value: 1
                    }, null, 512), [
                      [_vModelRadio, $setup.selectedUserType]
                    ]),
                    _createTextVNode(" Participant ")
                  ]),
                  _createElementVNode("label", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "local",
                      name: "UserType",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedUserType) = $event)),
                      value: 5
                    }, null, 512), [
                      [_vModelRadio, $setup.selectedUserType]
                    ]),
                    _createTextVNode(" Locals ")
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "employer",
                      name: "UserType",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedUserType) = $event)),
                      value: "6"
                    }, null, 512), [
                      [_vModelRadio, $setup.selectedUserType]
                    ]),
                    _createTextVNode(" Employers ")
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "payroll_company",
                      name: "UserType",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedUserType) = $event)),
                      value: "7"
                    }, null, 512), [
                      [_vModelRadio, $setup.selectedUserType]
                    ]),
                    _createTextVNode(" Payroll Company"),
                    _hoisted_14,
                    _hoisted_15
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                ($setup.selectedUserType != 1)
                  ? (_openBlock(), _createBlock(_component_LocalOptions, {
                      key: 0,
                      selectedUserType: $setup.selectedUserType,
                      registerType: $setup.registerType,
                      onChangeType: $setup.handleTypeChange
                    }, null, 8, ["selectedUserType", "registerType", "onChangeType"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("form", _hoisted_21, [
                ($setup.selectedUserType === 1)
                  ? (_openBlock(), _createBlock(_component_ParticipantFields, {
                      key: 0,
                      securityQuestions: $setup.securityQuestions,
                      errors: $setup.errors,
                      loadingSubmit: $setup.loadingSubmit,
                      onRegister: $setup.submitForm,
                      onResetErrors: $setup.resetErrrors
                    }, null, 8, ["securityQuestions", "errors", "loadingSubmit", "onRegister", "onResetErrors"]))
                  : ($setup.selectedUserType == 5 || $setup.selectedUserType == 3)
                    ? (_openBlock(), _createBlock(_component_LocalFields, {
                        key: 1,
                        securityQuestions: $setup.securityQuestions,
                        states: $setup.states,
                        onRegister: $setup.submitForm,
                        onResetErrors: $setup.resetErrrors,
                        loadingSubmit: $setup.loadingSubmit,
                        localRequest: $setup.localRequest,
                        authRequest: $setup.authRequest,
                        errors: $setup.errors,
                        registerType: $setup.registerType,
                        success: $setup.success
                      }, null, 8, ["securityQuestions", "states", "onRegister", "onResetErrors", "loadingSubmit", "localRequest", "authRequest", "errors", "registerType", "success"]))
                    : ($setup.selectedUserType == 6 || $setup.selectedUserType == 7)
                      ? (_openBlock(), _createBlock(_component_EmployerFields, {
                          key: 2,
                          securityQuestions: $setup.securityQuestions,
                          employerRequest: $setup.employerRequest,
                          onResetErrors: $setup.resetErrrors,
                          employerType: $setup.employerType,
                          states: $setup.states,
                          loadingSubmit: $setup.loadingSubmit,
                          onRegister: $setup.submitForm,
                          errors: $setup.errors,
                          success: $setup.success
                        }, null, 8, ["securityQuestions", "employerRequest", "onResetErrors", "employerType", "states", "loadingSubmit", "onRegister", "errors", "success"]))
                      : _createCommentVNode("", true)
              ]),
              _hoisted_22
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_PublicFooter)
  ], 64))
}